export const overflowVariants = {
  overflow: {
    auto: 'overflow-auto',
    hidden: 'overflow-hidden',
    clip: 'overflow-clip',
    visible: 'overflow-visible',
    scroll: 'overflow-scroll',
  },
  'overflow-sm': {
    auto: 'sm:overflow-auto',
    hidden: 'sm:overflow-hidden',
    clip: 'sm:overflow-clip',
    visible: 'sm:overflow-visible',
    scroll: 'sm:overflow-scroll',
  },
  'overflow-md': {
    auto: 'md:overflow-auto',
    hidden: 'md:overflow-hidden',
    clip: 'md:overflow-clip',
    visible: 'md:overflow-visible',
    scroll: 'md:overflow-scroll',
  },
  'overflow-lg': {
    auto: 'lg:overflow-auto',
    hidden: 'lg:overflow-hidden',
    clip: 'lg:overflow-clip',
    visible: 'lg:overflow-visible',
    scroll: 'lg:overflow-scroll',
  },
  'overflow-xl': {
    auto: 'xl:overflow-auto',
    hidden: 'xl:overflow-hidden',
    clip: 'xl:overflow-clip',
    visible: 'xl:overflow-visible',
    scroll: 'xl:overflow-scroll',
  },
  'overflow-x': {
    auto: 'overflow-x-auto',
    hidden: 'overflow-x-hidden',
    clip: 'overflow-x-clip',
    visible: 'overflow-x-visible',
    scroll: 'overflow-x-scroll',
  },
  'overflow-x-sm': {
    auto: 'sm:overflow-x-auto',
    hidden: 'sm:overflow-x-hidden',
    clip: 'sm:overflow-x-clip',
    visible: 'sm:overflow-x-visible',
    scroll: 'sm:overflow-x-scroll',
  },
  'overflow-x-md': {
    auto: 'md:overflow-x-auto',
    hidden: 'md:overflow-x-hidden',
    clip: 'md:overflow-x-clip',
    visible: 'md:overflow-x-visible',
    scroll: 'md:overflow-x-scroll',
  },
  'overflow-x-lg': {
    auto: 'lg:overflow-x-auto',
    hidden: 'lg:overflow-x-hidden',
    clip: 'lg:overflow-x-clip',
    visible: 'lg:overflow-x-visible',
    scroll: 'lg:overflow-x-scroll',
  },
  'overflow-x-xl': {
    auto: 'xl:overflow-x-auto',
    hidden: 'xl:overflow-x-hidden',
    clip: 'xl:overflow-x-clip',
    visible: 'xl:overflow-x-visible',
    scroll: 'xl:overflow-x-scroll',
  },
  'overflow-y': {
    auto: 'overflow-y-auto',
    hidden: 'overflow-y-hidden',
    clip: 'overflow-y-clip',
    visible: 'overflow-y-visible',
    scroll: 'overflow-y-scroll',
  },
  'overflow-y-sm': {
    auto: 'sm:overflow-y-auto',
    hidden: 'sm:overflow-y-hidden',
    clip: 'sm:overflow-y-clip',
    visible: 'sm:overflow-y-visible',
    scroll: 'sm:overflow-y-scroll',
  },
  'overflow-y-md': {
    auto: 'md:overflow-y-auto',
    hidden: 'md:overflow-y-hidden',
    clip: 'md:overflow-y-clip',
    visible: 'md:overflow-y-visible',
    scroll: 'md:overflow-y-scroll',
  },
  'overflow-y-lg': {
    auto: 'lg:overflow-y-auto',
    hidden: 'lg:overflow-y-hidden',
    clip: 'lg:overflow-y-clip',
    visible: 'lg:overflow-y-visible',
    scroll: 'lg:overflow-y-scroll',
  },
  'overflow-y-xl': {
    auto: 'xl:overflow-y-auto',
    hidden: 'xl:overflow-y-hidden',
    clip: 'xl:overflow-y-clip',
    visible: 'xl:overflow-y-visible',
    scroll: 'xl:overflow-y-scroll',
  },
}
